/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
import thdCustomer from "@thd-olt-global/thd-customer";
import {getQuantumMetricUserId, getQuantumMetricSessionId, getEmbraceCookie} from "./";
import { getCookie } from "./cookies";

function getLogInfo(obj) {
  if(obj?.rows && obj.rows.length && obj?.rows[0].columns) {
    return obj.rows[0].columns
  }
  return {};
}

const NewRelic = () => (
  Object.create({
    setQuantumMetric() {
      if(typeof window.newrelic !== "undefined" &&
        typeof window.newrelic.setCustomAttribute === "function"){
        window.newrelic.setCustomAttribute("QMSessionId", getCookie("QuantumMetricSessionID"));
        window.newrelic.setCustomAttribute("QMUserId", getCookie("QuantumMetricUserID"));
      }
    },

    logApiResponse(obj = {}) {
      try {
        const objClone = getLogInfo(obj);
        objClone["browserCookies"] = document.cookie;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["referrer"] = document.referrer;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("securityApiResponse", objClone);
        }

      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic:logApiResponse ", e)
      }
    },

    setCustomAttribute(attr, value) {
      try {
        if (window && window.newrelic && window.newrelic.setCustomAttribute) {
          window.newrelic.setCustomAttribute(attr, `${value} `);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while setting custom attr in New Relic ", e);
      }
    },

    logDeviceDeletion(deviceInfo) {
      try {
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("SspSignoutDeviceInfo", deviceInfo);
        }
      } catch(e) {
        // eslint-disable-next-line no-console
        console.error("Exception while setting logging device deletion info in New Relic ", e);
      }
    },

    logWebAuthnSuccess(flow) {
      try {
        const objClone = {};
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["browserCookies"] = document.cookie;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["WebAuthnSuccess"] = `WebAuthn Enrollment Successful: ${flow}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction(`WebAuthnSecurityPage ${flow}`, objClone);
        }

      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    logWebAuthnFailure(obj = {}, phase) {
      try {
        const objClone = getLogInfo(obj);
        objClone["email"] = thdCustomer.email;
        objClone["svocID"] = thdCustomer.svocID;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["browserCookies"] = document.cookie;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["WebAuthnFailurePhase"] = phase;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("WebAuthnSecurityPageFailure", objClone);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    logWebAuthnStartingFlow(flow) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["WebAuthn Flow"] = flow;
        objClone["mobileDeviceId"] = getEmbraceCookie();
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("WebAuthnSecurityPageStarted", objClone);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    /**
     * Native App Logging for WebAuthn
     * @param {*} eventName 
     * @param {*} payload 
     * 
     * 
     */

    nativeAppWebAuthnUpgradeStart(eventName="", payload={}) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["nativeAppWebAuthnUpgradeStart"] = `Event name: ${eventName}, payload: ${payload && JSON.stringify(payload)}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("nativeAppWebAuthn", objClone);
        }
      } catch (e) {
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    nativeAppWebAuthnSubscription(eventName="", payload={}) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["nativeAppWebAuthnSubscription"] = `Event name: ${eventName}, payload: ${payload && JSON.stringify(payload)}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("nativeAppWebAuthn", objClone);
        }
      } catch (e) {
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    nativeAppWebAuthnSuccess(eventName="") {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["nativeAppWebAuthnSuccess"] = `Event name: ${eventName}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("nativeAppWebAuthn", objClone);
        }
      } catch (e) {
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    nativeAppWebAuthnFailure(eventName="", error={}) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["nativeAppWebAuthnFailure"] = `Event name: ${eventName}, payload: ${error && JSON.stringify(error)}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("nativeAppWebAuthn", objClone);
        }
      } catch (e) {
        console.error("Exception while logging to New Relic: WebAuthn", e)
      }
    },

    logLifecycleEventReceived(eventName, payload) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["miscellaneous"] = `Event name: ${eventName}, payload: ${payload && JSON.stringify(payload)}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("lifeCycleEventReceived", objClone);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic: lifeCycleEventReceived", e)
      }
    },

    logLifecycleEventSent(eventName, payload) {
      try {
        const objClone = {};
        objClone["browserCookies"] = document.cookie;
        objClone["email"] = thdCustomer.email;
        objClone["CustomerType"] = thdCustomer.customerType;
        objClone["quantumUserId"] = getQuantumMetricUserId();
        objClone["quantumSessionId"] = getQuantumMetricSessionId();
        objClone["mobileDeviceId"] = getEmbraceCookie();
        objClone["miscellaneous"] = `Event name: ${eventName}, payload: ${payload && JSON.stringify(payload)}`;
        if (window && typeof window.newrelic !== "undefined" && typeof window.newrelic.addPageAction === "function") {
          window.newrelic.addPageAction("lifeCycleEventSent", objClone);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Exception while logging to New Relic: lifeCycleEventSent", e)
      }
    },
  })
);



const newRelic = NewRelic();

export default newRelic;